export default "__VITE_ASSET__BRwc0_Av__"